module.exports = __webpack_public_path__ + "static/media/game.a8ee82d4.svg";